import { createContext } from "react";

export interface EstimateContractContextType {
    values: any;
    setValues: any;
    referenceValue: any;
    initLoading: boolean;
    setInitLoading: (loading: boolean) => void;
}

const EstimateContractContext = createContext<
    EstimateContractContextType | undefined
>(undefined);

export default EstimateContractContext;
